import React, { useState } from "react";
import TemplateArticleHelp from "../TemplateArticleHelp/TemplateArticleHelp";
import styles from "./YourAccount.module.css";
import { ReactComponent as SettingGreenIcon } from "../../../assets/SettingGreenIcon.svg";
import { ReactComponent as SettingGrayIcon } from "../../../assets/SettingGrayIcon.svg";
import { ReactComponent as GrayDotsAppIcon } from "../../../assets/GrayDotsAppIcon.svg";
import { ReactComponent as ConectionsGrayIcon } from "../../../assets/ConectionsGrayIcon.svg";
import { ReactComponent as ArrowDownBold } from "../../../assets/arrowDownBold.svg";
import { useTranslation } from "react-i18next";

const YourAccount = ({setSelectedCategory}) => {
  const { t } = useTranslation("helpPage");

  const [activeArticles, setActiveArticles] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
  });

  const handleClick = (index) => {
    setActiveArticles((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div>
      <TemplateArticleHelp
           title={t("yourAccount")}
           description={t("yourAccountDescription")}
        Icon={SettingGreenIcon}
        setSelectedCategory={setSelectedCategory}
      >
        <div className={styles.articlesContent}>
          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(1)} 
            >
              {t('currentPlanHistory')} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[1] ? "auto" : "0px", 
              }}
            >
                {t("currentPlanHistoryDescription")}
              <ul>
                <li>{t("reviewPaymentHistory")}</li>
                <li>{t("changePlan")}</li>
                <li>{t("overlimitNotification")}</li>
              </ul>
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(2)} 
            >
               {t("language")}  <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[2] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
         {t("languageDescription")}
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(3)} 
            >
               {t("currency")}  <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[3] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
               {t("currencyDescription")}
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(4)} 
            >
               {t("chats")}  <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[4] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
          {t("chatsDescription")}
            </div>
          </div>

          <div className={styles.article}>
            <div
              className={styles.articleTitle}
              onClick={() => handleClick(5)} 
            >
               {t("connections")} <ArrowDownBold />
            </div>
            <div
              className={styles.articleInfo}
              style={{
                height: activeArticles[5] ? "auto" : "0px", 
                overflow: "hidden", 
              }}
            >
             {t("connectionsDescription")}
             <ol>
                <li>{t("setupAutomation")}</li>
                <li>{t("workflowOrchestration")}</li>
              </ol>
              <ConectionsGrayIcon />
              <p>{t("manageConnections")}</p>
              <div className={styles.YourAccountConfigIcons}>
                <SettingGrayIcon /> &gt; <GrayDotsAppIcon />
              </div>
            </div>
          </div>
        </div>
      </TemplateArticleHelp>
    </div>
  );
};

export default YourAccount;
